import * as React from "react"

const SearchIcon = (props) => (
  <svg
    height={50}
    width={50}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    xmlSpace="preserve"
    {...props}
  >
    <path
      fill="#231F20"
      d="M20.745 32.62c2.883 0 5.606-1.022 7.773-2.881L39.052 40.3a.996.996 0 0 0 1.414.002 1 1 0 0 0 .002-1.414L29.925 28.319c3.947-4.714 3.717-11.773-.705-16.205-2.264-2.27-5.274-3.52-8.476-3.52s-6.212 1.25-8.476 3.52c-4.671 4.683-4.671 12.304 0 16.987a11.9 11.9 0 0 0 8.477 3.519zm-7.06-19.094c1.886-1.891 4.393-2.932 7.06-2.932s5.174 1.041 7.06 2.932c3.895 3.905 3.895 10.258 0 14.163-1.886 1.891-4.393 2.932-7.06 2.932s-5.174-1.041-7.06-2.932c-3.894-3.905-3.894-10.258 0-14.163z"
    />
  </svg>
)

export default SearchIcon


// WEBPACK FOOTER //
// ./src/ui/components/Navigation/Search/searchIcon.js